import {ITEM_VIEW_CHAT, ITEM_VIEW_DISCUSSION, ItemViewType} from "../../gd/app-manager/item-view";
import SessionEventProto from "../session-event-proto";
import {EVENT_BUS_CHAT_DELETED_MESSAGE} from "../../model2/chat/chat/const";

export default class SessionEvent_ChatMessageDelete extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    async process() {

        const chatItemView            = gd.itemView.findByContainerId(ItemViewType.ITEM_VIEW_CHAT);
        const discussionItemView      = gd.itemView.findByContainerId(ItemViewType.ITEM_VIEW_DISCUSSION);
        const chatView      = gd.getApp()

        const deleteMessageOnView =
            (chatItemView && chatItemView.app.chatId === this.data.chatId) || // chatView app
            (discussionItemView && discussionItemView.app.controller.id === this.data.chatId) || // discussionView app
            // @ts-ignore
            (chatView && chatView.chatId === this.data.chatId)   // chat app


        if (deleteMessageOnView) {
            gd.bus.triggerEvent(EVENT_BUS_CHAT_DELETED_MESSAGE, this.data);
        }
    }
};